var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilityPrecipitation01 = function SvgProbabilityPrecipitation01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 617.7 447.61",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "probability_precipitation-01_svg2__a",
    x1: 74.98,
    x2: 458.98,
    y1: 246.89,
    y2: -51.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_precipitation-01_svg2__a",
    id: "probability_precipitation-01_svg2__b",
    x1: 127.67,
    x2: 511.67,
    y1: 314.78,
    y2: 16.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_precipitation-01_svg2__a",
    id: "probability_precipitation-01_svg2__c",
    x1: 28.47,
    x2: 412.47,
    y1: 186.95,
    y2: -111.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_precipitation-01_svg2__a",
    id: "probability_precipitation-01_svg2__d",
    x1: 242.52,
    x2: 626.52,
    y1: 462.77,
    y2: 164.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_precipitation-01_svg2__a",
    id: "probability_precipitation-01_svg2__e",
    x1: 263.79,
    x2: 647.79,
    y1: 490.19,
    y2: 192.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_precipitation-01_svg2__a",
    id: "probability_precipitation-01_svg2__f",
    x1: 177.74,
    x2: 561.74,
    y1: 379.3,
    y2: 81.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_precipitation-01_svg2__a",
    id: "probability_precipitation-01_svg2__g",
    x1: 309.87,
    x2: 693.87,
    y1: 549.57,
    y2: 251.57
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.78 0C76.91 0 0 76.91 0 171.78s76.91 171.78 171.78 171.78 171.78-76.91 171.78-171.78S266.65 0 171.78 0M75.39 143.18q-6.15-10.2-6.15-22.8c0-12.6 2.07-16.3 6.23-23.1q6.225-10.2 16.5-16.05c6.85-3.9 14.32-5.85 22.42-5.85s15.7 2 22.5 6 12.23 9.4 16.27 16.2c4.05 6.8 6.08 14.4 6.08 22.8s-2.08 16.15-6.23 22.95-9.63 12.15-16.42 16.05q-10.2 5.85-22.2 5.85c-12 0-15.73-1.97-22.57-5.92-6.85-3.95-12.33-9.32-16.43-16.13m55.5 141h-42.3l121.2-210h42.3zm134.47-23.4c-4.05 6.8-9.5 12.23-16.35 16.28s-14.43 6.08-22.73 6.08-15.85-2.07-22.65-6.23q-10.2-6.225-16.2-16.5c-4-6.85-6-14.22-6-22.12 0-8.6 2.07-16.3 6.22-23.1s9.65-12.17 16.5-16.12 14.22-5.92 22.12-5.92q12.9 0 23.1 6.3c6.8 4.2 12.17 9.73 16.12 16.58s5.93 14.28 5.93 22.27-2.03 15.7-6.08 22.5Z",
    style: {
      fill: "url(#probability_precipitation-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 218.18q-8.1 0-13.95 5.85t-5.85 14.25c0 8.4 1.95 10.05 5.85 13.95q5.85 5.85 13.95 5.85c8.1 0 10.35-1.95 14.25-5.85q5.85-5.85 5.85-13.95c0-8.1-1.95-10.35-5.85-14.25q-5.85-5.85-14.25-5.85",
    style: {
      fill: "url(#probability_precipitation-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39 140.18c5.4 0 10.05-1.92 13.95-5.77s5.85-8.52 5.85-14.02-1.95-10.3-5.85-14.1q-5.85-5.7-13.95-5.7c-8.1 0-10.23 1.9-14.17 5.7-3.95 3.8-5.93 8.5-5.93 14.1s1.97 10.18 5.93 14.02c3.95 3.85 8.67 5.77 14.17 5.77",
    style: {
      fill: "url(#probability_precipitation-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.52 343.87-27.46 54.08c-2.8 5.16-4.36 10.9-4.54 16.77-.03 8.63 3.3 16.94 9.28 23.17a31.46 31.46 0 0 0 22.72 9.73c8.58 0 16.79-3.52 22.72-9.73a33.28 33.28 0 0 0 9.28-23.17 39.4 39.4 0 0 0-4.35-16.45zm13.5 85.12c-7.48 7.4-19.53 7.4-27.01 0a20.44 20.44 0 0 1-5.7-14.27c.21-3.69 1.21-7.29 2.94-10.56l16.26-32 16.38 32.13c1.64 3.25 2.6 6.8 2.82 10.43.03 5.32-2.01 10.44-5.7 14.27Z",
    style: {
      fill: "url(#probability_precipitation-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.12 318.27-27.46 54.08c-2.8 5.16-4.36 10.9-4.54 16.77-.03 8.63 3.3 16.94 9.28 23.17a31.46 31.46 0 0 0 22.72 9.73c8.58 0 16.79-3.52 22.72-9.73a33.28 33.28 0 0 0 9.28-23.17 39.4 39.4 0 0 0-4.35-16.45zm13.5 85.12c-7.48 7.4-19.53 7.4-27.01 0a20.44 20.44 0 0 1-5.7-14.27c.21-3.69 1.21-7.29 2.94-10.56l16.26-32 16.38 32.13c1.64 3.25 2.6 6.8 2.82 10.43.03 5.32-2.01 10.44-5.7 14.27Z",
    style: {
      fill: "url(#probability_precipitation-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.45 137.4c.31-2.61.46-5.24.45-7.87-.35-37.44-30.97-67.52-68.42-67.2a68.75 68.75 0 0 0-34.05 8.96 106.37 106.37 0 0 0-77.5-33.28c-22.19-.16-42.87 6.6-59.94 18.28 2.8 3.23 5.48 6.55 8.05 9.98 14.84-9.92 32.71-15.64 51.9-15.47a93.35 93.35 0 0 1 71.42 32.9l3.71 4.42 4.74-3.26a56.54 56.54 0 0 1 31.68-9.73c30.37-.32 55.26 24.03 55.62 54.4-.02 3.92-.45 7.82-1.28 11.65l-1.54 6.72 6.85 1.02c33.59 4.4 58.49 33.36 57.79 67.23-.75 36.68-31.1 65.81-67.78 65.06H320.04c-3.59 4.45-7.39 8.72-11.4 12.8h228.5c37.69.62 70.6-25.4 78.69-62.22 9.39-42.74-17.65-85-60.39-94.39Z",
    style: {
      fill: "url(#probability_precipitation-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.72 343.87-27.46 54.08c-2.8 5.16-4.36 10.9-4.54 16.77a33.18 33.18 0 0 0 9.28 23.17 31.46 31.46 0 0 0 22.72 9.73c8.58 0 16.79-3.52 22.72-9.73a33.28 33.28 0 0 0 9.28-23.17 39.4 39.4 0 0 0-4.35-16.45zm13.5 85.12c-7.48 7.4-19.53 7.4-27.01 0a20.44 20.44 0 0 1-5.7-14.27c.21-3.69 1.21-7.29 2.94-10.56l16.26-32 16.38 32.13c1.64 3.25 2.6 6.8 2.82 10.43.03 5.32-2.01 10.44-5.7 14.27Z",
    style: {
      fill: "url(#probability_precipitation-01_svg2__g)"
    }
  }));
};
export default SvgProbabilityPrecipitation01;